import { PayloadAction } from "@reduxjs/toolkit";
import { QuoteCreateState, EventSchedulerState } from "../types";

const eventSchedulerReducers = {
  setEventScheduler: (
    state: QuoteCreateState,
    action: PayloadAction<EventSchedulerState>
  ) => {
    state.eventScheduler = action.payload;
  },
};

export default eventSchedulerReducers;
